import type { ReactNode } from "react";
import { useCallback } from "react";

import { Sms2faSupportedCountriesUrl } from "@simplyk/common";

import { useLocaleContext } from "@/common/contexts/LocaleContext";
import { PHONE_COUNTRY_NOT_ALLOWED } from "@/common/helpers/validators";
import { Trans } from "@/common/hooks/useTranslate";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { DashboardLink } from "@/dashboard-design-system/Link";

export const usePhoneCountryNotAllowedErrorMessage = (): ((message: string | undefined) => ReactNode) => {
  const { locale } = useLocaleContext();
  const supportUrl = Sms2faSupportedCountriesUrl[locale];

  return useCallback(
    (message: string | undefined): ReactNode => {
      if (message === PHONE_COUNTRY_NOT_ALLOWED) {
        return (
          <Trans
            space="dashboard"
            i18nKey="settings.twoFactorAuthBySmsModal.setup.phoneNumber.countryNotAllowed"
            components={{
              Link: <DashboardLink href={supportUrl} target="_blank" rel="noopener noreferrer" />,
            }}
          />
        );
      }
      return message;
    },
    [supportUrl]
  );
};
